import React from "react";

import { Link } from "@hdir/ui/link";
import { KeypointsData } from "../../../site/parts/highcharts/types.d";

type HighchartsKeyPointsProps = {
  keypointIcons: {
    iconSrc: string,
    iconAlt: string
  }[]
  // eslint-disable-next-line react/require-default-props
  keypointTitle?: string
  municipalityName: string
  keypointsData: KeypointsData
  keypointLink?: string
  keypointLinkTitle?: string
}

function HighchartsKeyPoints({
  keypointsData, keypointIcons, keypointTitle, municipalityName, keypointLink, keypointLinkTitle
}: HighchartsKeyPointsProps) {
  const GRID_COLS_DESKTOP: Record<1 | 2 | 3 | 4, string> = {
    1: "tablet:not-grid-cols-1",
    2: "tablet:not-grid-cols-2",
    3: "tablet:not-grid-cols-3",
    4: "tablet:not-grid-cols-2"
  };

  const count = keypointsData?.facts ? Object.keys(keypointsData?.facts).length as 1 | 2 | 3 | 4 : 4;
  const colsClass = GRID_COLS_DESKTOP[count];
  const rowsClass = count === 4 ? "tablet:not-grid-rows-2" : "";

  return (
    <>
      <div className="mx-auto flex not-flex-col">
        <h2 className="mb-lg font-bold tw-title-and-preface-max-w">{keypointTitle || `${municipalityName} kommune (${keypointsData.aargang})`}</h2>
        <ul className={`grid not-grid-cols-1 gap-md list-none p-0 mt-0 pl-4 ${colsClass} ${rowsClass}`}>
          {Object.entries(keypointsData.facts).map(([key, facts], index) => (
            <li
              key={`keypoint-${key}`}
              className="flex not-flex-row tablet:not-flex-col mb-md gap-md"
            >
              <div className="h-24">
                <img className="w-auto h-full" src={keypointIcons[index].iconSrc} alt={keypointIcons[index].iconAlt} />
              </div>
              <div>
                {/* eslint-disable-next-line react/no-danger */}
                <p className="text-xl font-semibold mb-sm">{facts.tekst}</p>
                {facts.liste && (
                  <ul>
                    {facts.liste.map((string) => (
                      <li>{string}</li>
                    ))}
                  </ul>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col gap-lg">
        <p className="opacity-75 text-s">
          {`Kilde: ${keypointsData.kilde}`}
        </p>
        {keypointLink && (
          <Link variant="button-secondary" size="medium" href={keypointLink}>
            {keypointLinkTitle}
          </Link>
        )}
      </div>
    </>
  );
}

export default function(props: Readonly<HighchartsKeyPointsProps>) {
  return <HighchartsKeyPoints {...props} />;
}
